import React from "react";
import { Modal, Form, Input, message, Button, InputNumber } from "antd";
import { useAsync } from "../../../../utils/use-async";
import { client } from "../../../../utils/api-client";
import { Spinner } from "../../../lib";

const AddSection = ({
  modal,
  fetchSubject,
  handleCancel,
  setModal,
  subjectId,
}) => {
  const { isLoading, run, isError, error } = useAsync();

  const addProfile = (values) => {
    run(
      client(`project/subject/${subjectId}/profile/add`, {
        body: values,
        method: "PUT",
      }).then((res) => {
        message.success(res.message);
        setModal(false);
        fetchSubject(subjectId);
      })
    );
  };

  return (
    <Modal title="Add Profile" visible={modal} onCancel={handleCancel}>
      <Form
        size="middle"
        layout="horizontal"
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={addProfile}
      >
        <Form.Item
          label="Profile"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter profile name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Budget"
          name="budget"
          rules={[
            {
              required: true,
              message: "Please enter budget!",
            },
          ]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16 } }}>
          <Button type="primary" htmlType="submit">
            Submit{" "}
            {isLoading && (
              <span style={{ marginLeft: "5px", verticalAlign: "middle" }}>
                <Spinner />
              </span>
            )}
          </Button>
        </Form.Item>
        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default AddSection;
